import { getPaymetricConfig } from "@eisinc/App/Services/SettingsService";
import { ApiHandlerNoParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { PaymetricConfig } from "@insite/client-framework/Services/SettingsService";
import { chain, GetPaymetricConfig } from "@insite/client-framework/Store/Context/Handlers/LoadPaymetricConfig";

type HandlerType = ApiHandlerNoParameter<PaymetricConfig>;

const xGetPaymetricConfig: HandlerType = async props => {
    props.apiResult = await getPaymetricConfig();
};

replaceInChain(chain, GetPaymetricConfig, xGetPaymetricConfig);
